import { createSlice } from '@reduxjs/toolkit';
import { addQuestionBank, deleteQuestionBank, getBloomInfo, getHintInfo, getQuestionBank, getQuestionData, getQuestionInfo, getSubjInfo, submitQuesBulkUpload } from 'services/store/actions/questionbankAction';

interface QusBankState {
    loading: boolean;
    questionbankData: any; // Define the type of userInfo
    error: any; // Define the type of error
    success: boolean;
    loading1: boolean;
    addquestionbank: any;
    error1: any;
    success1: boolean;
    loading2: boolean;
    deletequestionbanks: any;
    error2: any;
    success2: boolean;
    //get question data
    loading3: boolean;
    questionInfo: any;
    error3: any;
    success3: boolean;
    loading4: boolean;
    error4: any;
    success4: boolean;
    bulkQuesInfo: any;
    loading5: boolean;
    error5: any;
    success5: boolean;
    quesDetailInfo: any;
    loading6:boolean;
    error6:any;
    success6:boolean;
    subjectInfo:any;
    loading7:boolean;
    error7:any;
    success7:boolean;
    hintInfo:any;
    loading8:boolean;
    success8:boolean;
    error8:any;
    bloomInfo:any;
}

const initialState: QusBankState = {
    loading: false,
    questionbankData: null,
    error: null,
    success: false,
    loading1: false,
    addquestionbank: null,
    error1: null,
    success1: false,
    loading2: false,
    deletequestionbanks: null,
    error2: null,
    success2: false,
    //question data
    loading3: false,
    questionInfo: null,
    error3: null,
    success3: false,
    loading4: false,
    error4: null,
    success4: false,
    bulkQuesInfo: null,
    loading5: false,
    quesDetailInfo: null,
    error5: null,
    success5: false,
    loading6:false,
    error6:null,
    success6:false,
    subjectInfo:null,
    loading7:false,
    error7:null,
    success7:false,
    hintInfo:null,
    loading8:false,
    error8:null,
    success8:false,
    bloomInfo:null,
};

const questionSlices = createSlice({
    name: 'questionbank',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            // questionbank user
            .addCase(getQuestionBank.pending, (state) => {
                state.loading = true;
                state.error = null;
                state.success = false;
            })
            .addCase(getQuestionBank.fulfilled, (state, { payload }) => {
                state.loading = false;
                state.questionbankData = payload;
                state.success = true;
            })
            .addCase(getQuestionBank.rejected, (state, { payload }) => {
                state.loading = false;
                state.error = payload;
                state.success = false;
            })
            //get question data
            .addCase(getQuestionData.pending, (state) => {
                state.loading3 = true;
                state.error3 = null;
                state.success3 = false;
            })
            .addCase(getQuestionData.fulfilled, (state, { payload }) => {
                state.loading3 = false;
                state.questionInfo = payload;
                state.success3 = true;
            })
            .addCase(getQuestionData.rejected, (state, { payload }) => {
                state.loading3 = false;
                state.error3 = payload;
                state.success3 = false;
            })
            // addquestionbank user
            .addCase(addQuestionBank.pending, (state) => {
                state.loading1 = true;
                state.error1 = null;
                state.success1 = false;
            })
            .addCase(addQuestionBank.fulfilled, (state, { payload }) => {
                state.loading1 = false;
                state.success1 = true;
                state.addquestionbank = payload;
            })
            .addCase(addQuestionBank.rejected, (state, { payload }) => {
                state.loading1 = false;
                state.success1 = false;
                state.error1 = payload;
            })
            // deletequestionbank user
            .addCase(deleteQuestionBank.pending, (state) => {
                state.loading2 = true;
                state.error2 = null;
                state.success2 = false;
            })
            .addCase(deleteQuestionBank.fulfilled, (state, { payload }) => {
                state.loading2 = false;
                state.success2 = true;
                state.deletequestionbanks = payload;
            })
            .addCase(deleteQuestionBank.rejected, (state, { payload }) => {
                state.loading2 = false;
                state.success2 = false;
                state.error2 = payload;
            })
            //question paper bulk upload
            .addCase(submitQuesBulkUpload.pending, (state) => {
                state.loading4 = true;
                state.error4 = null;
                state.success4 = false;
                state.bulkQuesInfo = null;
            })
            .addCase(submitQuesBulkUpload.fulfilled, (state, { payload }) => {
                state.loading4 = false;
                state.success4 = true;
                state.bulkQuesInfo = payload;
            })
            .addCase(submitQuesBulkUpload.rejected, (state, { payload }) => {
                state.loading4 = false;
                state.success4 = false;
                state.error4 = payload;
            })
            .addCase(getQuestionInfo.pending, (state) => {
                state.loading5 = true;
                state.error5 = null;
                state.success5 = false;
                state.quesDetailInfo = null;
            })
            .addCase(getQuestionInfo.fulfilled, (state, { payload }) => {
                state.loading5 = false;
                state.success5 = true;
                state.quesDetailInfo = payload;
            })
            .addCase(getQuestionInfo.rejected, (state, { payload }) => {
                state.loading5 = false;
                state.success5 = false;
                state.error5 = payload;
            })
            .addCase(getSubjInfo.pending, (state) => {
                state.loading6 = true;
                state.error6 = null;
                state.success6 = false;
                state.subjectInfo = null;
            })
            .addCase(getSubjInfo.fulfilled, (state, { payload }) => {
                state.loading6 = false;
                state.success6 = true;
                state.subjectInfo = payload;
            })
            .addCase(getSubjInfo.rejected, (state, { payload }) => {
                state.loading6 = false;
                state.success6 = false;
                state.error6 = payload;
            })
            .addCase(getHintInfo.pending, (state) => {
                state.loading7 = true;
                state.error7 = null;
                state.success7 = false;
                state.hintInfo = null;
            })
            .addCase(getHintInfo.fulfilled, (state, { payload }) => {
                state.loading7 = false;
                state.success7 = true;
                state.hintInfo = payload;
            })
            .addCase(getHintInfo.rejected, (state, { payload }) => {
                state.loading7 = false;
                state.success7 = false;
                state.error7 = payload;
            })
            .addCase(getBloomInfo.pending, (state) => {
                state.loading8 = true;
                state.error8 = null;
                state.success8 = false;
                state.bloomInfo = null;
            })
            .addCase(getBloomInfo.fulfilled, (state, { payload }) => {
                state.loading8 = false;
                state.success8 = true;
                state.bloomInfo = payload;
            })
            .addCase(getBloomInfo.rejected, (state, { payload }) => {
                state.loading8 = false;
                state.success8 = false;
                state.error8 = payload;
            });
    },
});
export default questionSlices.reducer;
